import React from 'react';
function Magic({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M12 3L10.088 8.813C9.99015 9.11051 9.82379 9.38088 9.60234 9.60234C9.38088 9.82379 9.11051 9.99015 8.813 10.088L3 12L8.813 13.912C9.11051 14.0099 9.38088 14.1762 9.60234 14.3977C9.82379 14.6191 9.99015 14.8895 10.088 15.187L12 21L13.912 15.187C14.0099 14.8895 14.1762 14.6191 14.3977 14.3977C14.6191 14.1762 14.8895 14.0099 15.187 13.912L21 12L15.187 10.088C14.8895 9.99015 14.6191 9.82379 14.3977 9.60234C14.1762 9.38088 14.0099 9.11051 13.912 8.813L12 3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 3V7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19 17V21" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 5H7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17 19H21" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Magic;
